import { createContext, Dispatch, SetStateAction } from 'react';

import { ZApiInstance } from 'src/modules/whatsapp/@types/models';
import {
  Chat,
  ChatMessage,
  ChatMessageTypes,
} from 'src/services/websocket/omnichannel/types';

export type UploadFile = {
  previewURL: string;
  file: File;
  message?: string;
};

export type Upload = {
  type: ChatMessageTypes;
  accept: string;
  uploadFiles: UploadFile[];
};

export type OmnichannelContextData = {
  connected: boolean;
  zApiInstance?: ZApiInstance;
  // setZApiInstance: Dispatch<SetStateAction<ZApiInstance | undefined>>;
  chats: Chat[];
  setChats: Dispatch<SetStateAction<Chat[]>>;
  selectedChat?: Chat;
  setSelectedChat: Dispatch<SetStateAction<Chat | undefined>>;
  selectedChatMessages: ChatMessage[];
  setSelectedChatMessages: Dispatch<SetStateAction<ChatMessage[]>>;
  answerMessage?: ChatMessage;
  setAnswerMessage: Dispatch<SetStateAction<ChatMessage | undefined>>;
  upload: Upload | null;
  setUpload: Dispatch<SetStateAction<Upload | null>>;
};

export const OmnichannelContext = createContext<OmnichannelContextData>({
  connected: false,
  // setZApiInstance: () => null,
  chats: [],
  setChats: () => null,
  setSelectedChat: () => null,
  selectedChatMessages: [],
  setSelectedChatMessages: () => null,
  setAnswerMessage: () => null,
  upload: null,
  setUpload: () => null,
});
